import React from 'react';
import { useTranslation } from '../../context/Internationalization';
import { NativeSelect, NativeSelectOption } from '../../shadcn/components/ui/native-select';
import { managerLogo as logo } from '../../assets/managerBranding';
import stadium from '../../assets/images/registration/stadium-seats.jpg';

// Adapted from the @shadcndesign sign-in-3 block: form on the left, photo
// with the brand message on the right (hidden on small screens).
export default function AuthLayout({ children, clubLogo }) {
  const { t, lang, switchLanguage } = useTranslation();
  return (
    <main className="min-h-screen gap-x-6 bg-background py-6 text-foreground supports-[min-height:100dvh]:min-h-dvh md:flex md:p-6">
      <div className="flex items-center justify-center md:w-1/2">
        <div className="w-full max-w-sm px-6 py-10 md:p-0">
          <div className="mb-6 flex items-center justify-between">
            <img src={logo} alt="PlayerDex Manager" className="size-9" />
            <NativeSelect aria-label={t('registration_language')} value={lang}
              onChange={(event) => switchLanguage(event.target.value)}>
              <NativeSelectOption value="gr">Ελληνικά</NativeSelectOption>
              <NativeSelectOption value="en">English</NativeSelectOption>
            </NativeSelect>
          </div>
          <div className="[&_h1]:text-balance [&_h1]:text-2xl [&_h1]:font-semibold md:[&_h1]:text-3xl">
            {children}
          </div>
        </div>
      </div>
      <aside
        className="relative hidden min-h-full w-1/2 flex-col-reverse overflow-hidden rounded-xl bg-cover bg-center md:flex"
        style={{ backgroundImage: `url(${stadium})` }}
      >
        <div className="absolute inset-0 bg-black opacity-60" />
        <div className="relative z-10 flex flex-col gap-4 p-12 text-white">
          <img src={clubLogo || logo} alt={clubLogo ? t('registration_logo_preview') : 'PlayerDex'}
            className="size-10 rounded-lg object-contain" />
          <h2 className="text-balance text-3xl leading-tight font-semibold">{t('registration_brand_title')}</h2>
          <p className="text-lg">{t('registration_brand_description')}</p>
          <p className="text-white/70">{t('registration_brand_details')}</p>
        </div>
      </aside>
    </main>
  );
}
